import { render, staticRenderFns } from "./ignoreModal.vue?vue&type=template&id=3bba8600&scoped=true&"
import script from "./ignoreModal.vue?vue&type=script&lang=js&"
export * from "./ignoreModal.vue?vue&type=script&lang=js&"
import style0 from "./ignoreModal.vue?vue&type=style&index=0&id=3bba8600&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba8600",
  null
  
)

export default component.exports